export default __webpack_public_path__ + "static/media/Americana.33d132e0.png";